export default __webpack_public_path__ + "static/media/thum1.9abea2d1.jpg";